<template>
  <div>
    <div class="item" v-for="item in assignmentsControl">
      <div class="is-clearfix mb-5">
        <div class="organization">{{ item.organization__name }}</div>
        <div class="term">{{ item.term_date | localedDate }}</div>
      </div>
      <div @click="openAssignment(item.id)" class="name">
        {{ item.name }}
      </div>
      <b-tag :type="`is-${stateColors[item.state]}`" class="ml-5">
        {{ $t(`workflow.states.${item.state}`) }}
      </b-tag>
      <div class="description" v-html="item.description"></div>
      <div class="tasks">
        <div class="task" v-for="task in item.tasks" @click="openTask(item.id, task.id)">
          <div class="is-clearfix">
            <div class="organization">
              <span class="executor" v-for="executor in task.executors">{{ executor }}</span>
            </div>
            <div class="term">{{ task.term_date | localedDate }}</div>
          </div>
          {{task.description}}
          <b-tag :type="`is-${stateColors[task.state]}`" class="ml-5">
            {{ $t(`workflow.states.${task.state}`) }}
          </b-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {stateColors} from '@/colorTypes'
  import PlanControlItem from '@/components/PlanControlItem'

  export default {
    components: {PlanControlItem},
    data() {
      return {stateColors}
    },
    methods: {
      openAssignment(documentId) {
        this.$router.push({
          name: 'documentDetail',
          params: {documentId}
        })
      },
      openTask(documentId, taskId) {
        this.$router.push({
          name: 'taskDetail',
          params: {taskId, documentId}
        })
      }
    },
    mounted() {
      this.$store.dispatch('Docflow/getAssignmentsControl', this.$route.params.documentId)
    },
    computed: {
      ...mapState('Docflow', ['assignmentsControl'])
    }
  }
</script>

<style lang="scss" scoped>
  .item {
    padding: 14px 20px;
    background: #f6f6f6;
    border-radius: 6px;
    margin-bottom: 10px;

    .task {
      background: #fff;
      padding: 7px 14px;
      border-radius: 6px;
      margin-top: 10px;
      cursor: pointer;
    }

    .name {
      font-size: 16px;
      font-weight: 500;
      display: inline-block;
      cursor: pointer;
    }

    .description {
      font-size: 12px;
      display: block;
    }

    .organization {
      font-size: 12px;
      color: #8a8a8a;
      float: left;
    }

    .term {
      font-size: 12px;
      color: #8a8a8a;
      float: right;
    }
  }
</style>
